import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function ComingSoon({ title, description, testId }) {
  return (
    <div data-testid={testId} className="text-white">
      <Seo />
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-radial-fade" />
        <div className="relative mx-auto max-w-3xl px-4 md:px-8 lg:px-12 py-24 md:py-32 text-center">
          <div className="inline-flex items-center rounded-full border border-[#FE7200]/30 bg-[#FE7200]/10 px-3 py-1 text-xs font-semibold tracking-wide text-[#FE7200]">
            Coming soon
          </div>
          <h1 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-[1.05]">
            {title}
          </h1>
          <p className="mt-5 text-base sm:text-lg text-zinc-300 max-w-xl mx-auto">
            {description}
          </p>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              data-testid={`${testId}-home-button`}
              className="inline-flex items-center gap-2 rounded-full bg-[#FE7200] px-6 py-3 text-sm font-bold uppercase tracking-wider text-black hover:bg-[#FF8C2E] transition-colors"
            >
              Back To Home
            </Link>
            <Link
              to="/contact"
              data-testid={`${testId}-contact-button`}
              className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-6 py-3 text-sm font-bold uppercase tracking-wider text-white hover:bg-white/10 transition-colors"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
